import { Component, h, Prop } from "@stencil/core";
import classNames from "classnames";
import { ActivityIndicatorProps } from "./f-activity-indicator-model";

@Component({
  tag: "f-activity-indicator",
  styleUrl: "f-activity-indicator.scss",
  shadow: true,
})
export class FActivityIndicator {
  @Prop() variant: ActivityIndicatorProps["variant"] = "default";

  render() {
    const activityIndicatorClass = classNames("a-activity-indicator", {
      [`a-activity-indicator--${this.variant}`]: this.variant,
    });
    return (
      <div class={activityIndicatorClass} data-test="activity-indicator">
        <div class="a-activity-indicator__top-box" />
        <div class="a-activity-indicator__bottom-box" />
      </div>
    );
  }
}
